import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.RequestModule.BeneficiaryStatusLegend', {
    greenText: 'You have paid this contact before',
    yellowText: 'First payment',
    redText: 'Payment details have changed',
    grayText: 'Not checked',
});
